import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import * as moment from 'moment';
import { map } from 'rxjs/operators';
import * as jwtDecode from 'jwt-decode';

import { SessionService } from './session.service';
import { environment } from 'src/environments/environment';
import { IClaim } from '../models/claim/claim.interface';
import { ISession } from '../models/session/session.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isAuthenticated$ = this.sessionServ.session$.pipe(
    map(session => this.isAuthenticated(session))
  );

  constructor(
    private router: Router,
    private sessionServ: SessionService
  ) {
  }

  isAuthenticated(session = this.sessionServ.getSession()) {
    if (session) {
      const now = moment();
      const expirationDate = session && moment(new Date(session.expiration));
      return session && session.accessToken && now.isBefore(expirationDate);
    } else {
      return false;
    }
  }

  hasPermission(permissionName: string) {
    const user = this.sessionServ.user;

    if (permissionName && user && user.permissions) {
      const permissions = user.permissions;

      if (permissions.find(elem => elem === permissionName || elem === `${environment.permissionPrefix}.*`)) {
        return true;
      } else {
        return false;
      }
    }

    return true;
  }

  login(token: string, login: string) {
    const claim: IClaim = jwtDecode(token);

    // Create user session
    const session = {
      accessToken: token,
      user: {
        id: claim.usuario_id,
        email: login,
        name: claim.given_name,
        permissions: claim.permission ? JSON.parse(claim.permission) : [],
        role: claim.role,
        fantasyName: claim.nome_fantasia,
        sapCode: claim.codigo_sap
      },
      expiration: claim.expiration_date,
    } as ISession;

    // Set session
    this.sessionServ.setSession(session);

    this.router.navigateByUrl('/');
  }

  logout() {
    this.sessionServ.reset();
    this.router.navigateByUrl('/login');
  }

  public getCookieSession(): string | null {
    const access_token = document.cookie.split('; ')
      .find(row => row.startsWith('access_token='));
    return access_token ? access_token.split('=')[1] : null;
  }

  public deleteCookie(name: string) {
    document.cookie = name + '=; Max-Age=-99999999; path=/';
  }


}
